var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66666 1.89136V5.33348C9.66666 5.80018 9.66666 6.03354 9.75749 6.2118C9.83738 6.3686 9.96487 6.49609 10.1217 6.57598C10.2999 6.66681 10.5333 6.66681 11 6.66681H14.4421M9.66666 14.1667H4.66666M11.3333 10.8334H4.66666M14.6667 8.3236V14.3334C14.6667 15.7335 14.6667 16.4336 14.3942 16.9684C14.1545 17.4388 13.772 17.8212 13.3016 18.0609C12.7669 18.3334 12.0668 18.3334 10.6667 18.3334H5.33333C3.9332 18.3334 3.23313 18.3334 2.69835 18.0609C2.22795 17.8212 1.8455 17.4388 1.60581 16.9684C1.33333 16.4336 1.33333 15.7335 1.33333 14.3334V5.66675C1.33333 4.26662 1.33333 3.56655 1.60581 3.03177C1.8455 2.56137 2.22795 2.17892 2.69835 1.93923C3.23313 1.66675 3.9332 1.66675 5.33333 1.66675H8.00981C8.62128 1.66675 8.92702 1.66675 9.21474 1.73582C9.46983 1.79707 9.71369 1.89808 9.93737 2.03515C10.1897 2.18975 10.4059 2.40594 10.8382 2.83832L13.4951 5.49517C13.9275 5.92755 14.1437 6.14374 14.2983 6.39604C14.4353 6.61972 14.5363 6.86358 14.5976 7.11867C14.6667 7.40639 14.6667 7.71213 14.6667 8.3236Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.2fbd9172a8d8899b0bb560ef93a57a69.svg";
export { ForwardRef as ReactComponent };